// src/components/ColumnManager.js
import React, { useState } from 'react';

const ColumnManager = ({ columns, setColumns, onClose }) => {
  const [localColumns, setLocalColumns] = useState([...columns]);

  const toggleVisibility = (id) => {
    setLocalColumns(localColumns.map(col =>
      col.id === id ? { ...col, visible: !col.visible } : col
    ));
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const newCols = [...localColumns];
    [newCols[index], newCols[index-1]] = [newCols[index-1], newCols[index]];
    // به‌روزرسانی order
    newCols.forEach((col, idx) => col.order = idx + 1);
    setLocalColumns(newCols);
  };

  const moveDown = (index) => {
    if (index === localColumns.length - 1) return;
    const newCols = [...localColumns];
    [newCols[index], newCols[index+1]] = [newCols[index+1], newCols[index]];
    newCols.forEach((col, idx) => col.order = idx + 1);
    setLocalColumns(newCols);
  };

  const applyChanges = () => {
    setColumns(localColumns);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content column-manager" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>مدیریت ستون‌ها</h3>
          <button className="close-modal" onClick={onClose}>✖</button>
        </div>
        <div className="modal-body">
          <ul className="columns-list">
            {localColumns.map((col, idx) => (
              <li key={col.id}>
                <label>
                  <input type="checkbox" checked={col.visible} onChange={() => toggleVisibility(col.id)} />
                  {col.label}
                </label>
                <div className="move-buttons">
                  <button onClick={() => moveUp(idx)} disabled={idx === 0}>▲</button>
                  <button onClick={() => moveDown(idx)} disabled={idx === localColumns.length-1}>▼</button>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="modal-footer">
          <button className="apply-btn" onClick={applyChanges}>اعمال</button>
          <button className="cancel-btn" onClick={onClose}>انصراف</button>
        </div>
      </div>
    </div>
  );
};

export default ColumnManager;